function initFlasher({ companyId }) {
  // 旺铺资源预载
  window._FLASHER_CONF_ = {
    prefetchPages: [
      {
        namespace: 'icbushop',
        id: companyId,
        opts: {
          autoWebpSuffix: true,
          event: 'load',
        },
      },
    ],
  };
}

export default initFlasher;
